import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from './AuthContext';
import { hostNameBack } from './constants';

export const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
    const [noOfBuyerServiceOrderUnread, setNoOfBuyerServiceOrderUnread] = useState(0);
    const [noOfSellerServiceOrderUnread, setNoOfSellerServiceOrderUnread] = useState(0);
    const [noOfBuyerProductOrderUnread, setNoOfBuyerProductOrderUnread] = useState(0);
    const [noOfSellerProductOrderUnread, setNoOfSellerProductOrderUnread] = useState(0);

    const { isLogin, user, isAdminLogin } = useContext(AuthContext);

    const checkUnreadStatus = async () => {
        if (!isLogin || !user || isAdminLogin) return;

        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            const buyerProductOrders = await axios.get(`${hostNameBack}/api/v1/orders/buyer/product/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const sellerProductOrders = await axios.get(`${hostNameBack}/api/v1/orders/seller/product/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const buyerServiceOrders = await axios.get(`${hostNameBack}/api/v1/orders/buyer/service/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const sellerServiceOrders = await axios.get(`${hostNameBack}/api/v1/orders/seller/service/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // sum all product-level noOfUnreadByBuyer
            const totalNoOfUnreadBuyerProductOrders = buyerProductOrders.data.orders.reduce(
                (acc, order) =>
                    acc +
                    order.products.reduce((prodAcc, product) => prodAcc + (product.noOfUnreadByBuyer || 0), 0),
                0
            );

            const totalNoOfUnreadSellerProductOrders = sellerProductOrders.data.orders.reduce(
                (acc, order) =>
                    acc +
                    order.products.reduce((prodAcc, product) => prodAcc + (product.noOfUnreadBySeller || 0), 0),
                0
            );

            // sum all order-level noOfUnreadByBuyer
            const totalNoOfUnreadBuyerServiceOrders = buyerServiceOrders.data.orders.reduce(
                (acc, order) => acc + (order.noOfUnreadByBuyer || 0),
                0
            );

            const totalNoOfUnreadSellerServiceOrders = sellerServiceOrders.data.orders.reduce(
                (acc, order) => acc + (order.noOfUnreadBySeller || 0),
                0
            );

            setNoOfBuyerProductOrderUnread(totalNoOfUnreadBuyerProductOrders);
            setNoOfSellerProductOrderUnread(totalNoOfUnreadSellerProductOrders);
            setNoOfBuyerServiceOrderUnread(totalNoOfUnreadBuyerServiceOrders);
            setNoOfSellerServiceOrderUnread(totalNoOfUnreadSellerServiceOrders);

        } catch (error) {
            console.error('Error checking unread status:', error);
        }
    };

    useEffect(() => {
        checkUnreadStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin, user, isAdminLogin]);

    const refreshNotifications = () => {
        checkUnreadStatus();
    };

    return (
        <NotificationsContext.Provider
            value={{
                noOfBuyerServiceOrderUnread,
                noOfSellerServiceOrderUnread,
                noOfBuyerProductOrderUnread,
                noOfSellerProductOrderUnread,
                refreshNotifications
            }}
        >
            {children}
        </NotificationsContext.Provider>
    );
};